import React, { useEffect, useMemo } from 'react';

import { Pressable, View } from 'react-native';

import getStyles from './styles';
import { CellProps } from './types';
import useIsLive from './useIsLive';

const TV_PARALLAX_PROPERTIES = { enabled: false };

const Cell = ({
    config,
    item,
    selected,
    appState,
    focusable = true,
    renderContent,
    onPress,
    onFocus,
    onBlur,
}: CellProps) => {
    const live = useIsLive(item.startTime, item.endTime, appState);

    const styles = useMemo(() => getStyles(config, item.type), [item.type]);

    const Content = useMemo(
        () => renderContent(item.rowIndex, selected, live),
        [renderContent, item, selected, live],
    );

    useEffect(() => {
        onBlur?.();
    }, [focusable]);

    return focusable ? (
        <Pressable
            accessible={false}
            style={styles.cell}
            onPress={onPress}
            onFocus={onFocus}
            onBlur={onBlur}
            // @ts-ignore
            tvParallaxProperties={TV_PARALLAX_PROPERTIES}
        >
            {Content}
        </Pressable>
    ) : (
        <View style={styles.cell}>{Content}</View>
    );
};

export default Cell;
